<template>
  <div class="div_sidebar">
    <img class="icon_logo" :src="logoSrc">
    <div class="cs_text_lg cs_align_center cs_font_bold title_sidebar_1">{{institutionName}}集团餐饮业<br>智慧运营管理平台</div>
    <div class="nav">
      <ul>
        <template v-for="(module,index) in modules">
          <li v-if="module.hasSubs" class="list"
               :class="{unfold:index===unfoldIndex}">
            <h1 @click="unfoldIndex === index?unfoldIndex = -1:unfoldIndex = index">
              <span :class="module.class"></span><i></i>{{module.name}}
            </h1>
            <div class="hide">
              <h2 v-for="subModule in module.subs"
                  :class="{sub_selected: subModule.subsPathName.indexOf($route.name)>-1}"
                  @click="$route.name===subModule.pathName?true:$router.push({name: subModule.pathName})">
                <span v-if="subModule.subsPathName.indexOf($route.name)>-1"></span>
                {{subModule.name}}
              </h2>
            </div>
          </li>
          <li v-else class="list">
            <h1 @click="btnJump(module,index)" :class="{color_yellow: module.subsPathName.indexOf($route.name)>-1}">
              <span :class="module.class"></span>{{module.name}}
            </h1>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
  import StorageConst from "../assets/utils/StorageConst";
  export default {
    name: "sidebar",
    props: {
      modules: {
        type: Array
      }
    },
    data: function () {
      return {
        unfoldIndex: this.calculateDefModuleIndex(),
        institutionName: "",
        logoSrc: "",
      }
    },
    created: function () {
      this.institutionName = this.$cookies.get(StorageConst.COOKIE_INSTITUTION_NAME);
      this.logoSrc = localStorage.getItem(StorageConst.LOCAL_LOGO_URL)+"?x-oss-process=style/side_bar";
    },
    methods: {
      calculateDefModuleIndex() {
        for (let i = 0; i < this.modules.length; i++) {
          if(this.modules[i].hasSubs){
            for (let j = 0; j < this.modules[i].subs.length; j++) {
              if (this.modules[i].subs[j].subsPathName.indexOf(this.$route.name)>-1) {
                return i;
              }
            }
          }else {
            if (this.modules[i].subsPathName.indexOf(this.$route.name)>-1) {
              return i;
            }
          }
        }
      },
      btnJump(module,index){
        this.unfoldIndex = this.unfoldIndex === index ? -1 : index;
        if(this.$route.name!==module.pathName){
          this.$router.push({name: module.pathName})
        }
      },
    }
  }
</script>

<style scoped>
  /*左侧菜单栏*/
  .div_sidebar {
    position: absolute;
    width: 242px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background: #FFFFFF;
  }

  .icon_logo {
    position: absolute;
    top: 42px;
    left: 86px;
    width: 70px;
    height: 56px;
  }

  .title_sidebar_1 {
    position: absolute;
    top: 120px;
    width: 100%;
    height: 24px;
    line-height: 24px;
    color: #4A4A4A;
  }

  .nav {
    margin-top: 200px;
    width: 234px;
  }

  h1, h2 {
    font-weight: normal;
    font-size: 12px
  }

  ul, li {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .list:first-child h1 {
    border-top: solid 1px #f6f7f9;
  }

  .icon_material {
    background: url('../assets/image/icon_material.png') no-repeat center;
  }

  .icon_device {
    background: url('../assets/image/icon_device.png') no-repeat center;
  }

  .icon_price {
    background: url('../assets/image/icon_price.png') no-repeat center;
  }
  .icon_organization {
    background: url('../assets/image/icon_organization.png') no-repeat center;
  }
  .icon_print_manage{
    background: url('../assets/image/icon_print_manage.png') no-repeat center;
  }
  .icon_supplier{
    background: url('../assets/image/icon_supplier.png') no-repeat center;
  }
  .icon_dc{
    background: url('../assets/image/icon_dc.png') no-repeat center;
  }
  .icon_shop{
    background: url('../assets/image/icon_shop.png') no-repeat center;
  }
  .icon_kitchen{
    background: url('../assets/image/icon_kitchen.png') no-repeat center;
  }
  .icon_kitchen{
    background: url('../assets/image/icon_kitchen.png') no-repeat center;
  }
  .icon_merchant{
    background: url('../assets/image/icon_merchant.png') no-repeat center;
  }
  .icon_role{
    background: url('../assets/image/icon_role.png') no-repeat center;
  }

  .icon_staff{
    background: url('../assets/image/icon_staff.png') no-repeat center;
  }

  .icon_brand{
    background: url('../assets/image/icon_brand.png') no-repeat center;
  }
  .icon_log{
    background: url('../assets/image/icon_log.png') no-repeat center;
  }

  /*一级标题*/
  .list h1 {
    position: relative;
    margin: 0;
    height: 62px;
    background-color: #fff;
    text-align: left;
    padding-left: 75px;
    line-height: 62px;
    font-size: 14px;
    color: #9B9B9B;
    border-bottom: solid 1px #f6f7f9;
    transition: .5s;
    cursor: pointer;
  }
  .list h1.color_yellow{
    font-weight: bold;
    color: #FFB54C;
  }
  /*一级标题图标*/
  .list span {
    position: absolute;
    left: 32px;
    top: 24px;
    width: 16px;
    height: 16px;
    background-size: 16px 16px;
  }

  /*一级标题下拉图标*/
  .list i {
    position: absolute;
    right: 18px;
    top: 23px;
    transform: rotate(0deg);
    transition: .5s;
    width: 13px;
    height: 13px;
    background: url('../assets/image/icon_select.png') no-repeat center;
    background-size: 13px 13px;
  }

  .list[class~=unfold] h1 i {
    transform: rotate(180deg);
  }

  .list[class~=unfold] .hide {
    height: auto;
  }

  /*二级标题*/
  .hide {
    overflow: hidden;
    transition: .5s;
    height: 0;
  }

  .hide h2 {
    position: relative;
    margin-left: 24px;
    margin-top: 4px;
    margin-bottom: 4px;
    width: 200px;
    height: 40px;
    line-height: 40px;
    padding-left: 63px;
    text-align: left;
    font-size: 14px;
    color: #9B9B9B;
    cursor: pointer;
  }

  .hide h2.sub_selected {
    font-weight: bold;
    box-shadow: 0 8px 14px 2px rgba(78, 80, 127, 0.11);
    border-radius: 20px;
    border: solid 1px #f7f7f7;
    color: #666666;
  }

  .sub_selected span {
    position: absolute;
    left: 9px;
    top: 16px;
    width: 7px;
    height: 7px;
    background: #ff6666;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue